'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../../../tslib.es6-CZ43up4V.js');
const react = require('@emotion/react');
const components_navigation_Button_BaseButton = require('../Button/BaseButton.cjs.js');

const colorMappings = {
  primary: "primary-dark",
  secondary: "secondary-dark"
};
function DarkBackgroundButton(_a) {
  var { size = "small", color = "primary" } = _a, props = tslib_es6.__rest(_a, ["size", "color"]);
  return react.jsx(components_navigation_Button_BaseButton.BaseButton, Object.assign({ color: colorMappings[color], size }, props));
}

exports.DarkBackgroundButton = DarkBackgroundButton;
//# sourceMappingURL=DarkBackgroundButton.cjs.js.map
